import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dataModel from '../../models/DataModel';
import _ from 'lodash';
import BaseComponent from '../../baseClasses/BaseComponent';
import UserAvatar from '../../components/UserAvatar';
import anime from 'animejs';
import './QuickerAssignErrorPopup.scss';

class QuickerAssignErrorPopup extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
    };

    this.closePopup = this.closePopup.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
    this.createUserErrors = this.createUserErrors.bind(this);
  }

  componentDidMount() {
    dataModel.setDisableAppBackground(true);
    this.expandPopup();
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps) {
  }

  expandPopup() {
    return anime({
      targets: this.quickerAssignErrorPopup,
      height: 343,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  collapsePopup(e, force) {
    return anime({
      targets: this.quickerAssignErrorPopup,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 200,
      complete: () => {
        this.closePopup();
      },
    });
  } 
  
  closePopup() {
    dataModel.setDisableAppBackground(false);
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  createUserErrors() {
    let { bulkAssignErrors } = this.props;
    let userRows = [];
    let userRow = [];
    let count = 0;
    bulkAssignErrors.forEach(user => {
      const userDisplay = <div className='user' key={user.id}>
        <div className='user-avatar-container'>
          <UserAvatar
            larger={true}
            user={user}
          />
        </div>
        <div className='user-name'>
          {user.name ? user.name : user.first_name + ' ' + user.last_name}
        </div>

      </div>;

      userRow.push(userDisplay);
      if (userRow.length == 4) {
        userRows.push(
          <div className='user-errors-row' key={count++}>
            {userRow}
          </div>
        );
        userRow = [];
      }
    });
    if (userRow.length) {
      userRows.push(
        <div className='user-errors-row' key={userRows.length}>
          {userRow}
        </div>
      );
    }
    return userRows;
  }

  render() {
    const userErrorsDisplay = this.createUserErrors();

    return (
      <article
        className='quicker-assign-error-popup'
        ref={el => this.quickerAssignErrorPopup = el}
      >
        <header className='quicker-assign-error-popup__header'>
          <div className='caption'>
            ATTENTION
          </div>
        </header>
        <div className='quicker-assign-error-popup__container'>
          <div className="explanatory-text">
            {this.props.fromBuilds ?
              'The following users were not assigned to one or more of the Builds selected due to conflicts in assignments' :
              'The following users were not assigned to one or more of the Tasks selected due to conflicts in assignments'}
          </div>
          <div className='user-errors-grid'>
            {userErrorsDisplay}
          </div>

        </div>
        <div className='quicker-assign-error-popup__button-container'>
          <button
            className={'okay-button'}
            onClick={this.collapsePopup}
          >
            OKAY
        </button>
        </div>
      </article>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    quickAssignments: state.new_users.quickAssignments,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    needsLogin: state.main ? state.main.needsLogin : null,
  };
};

export default withRouter(connect(mapStateToProps)(QuickerAssignErrorPopup));



// WEBPACK FOOTER //
// ./src/components/QuickerAssignErrorPopup/index.js